import React, { useEffect, useState } from "react";
import {
	ButtonState,
	ButtonType,
	IconProperties,
} from "../ZFButton/ZFButton.d";
import ZFButton from "../ZFButton/ZFButton";

const ZFGroupButton: React.FC<IZFGroupButton> = (props: IZFGroupButton) => {
	const [currentActiveIndex, setCurrentActiveIndex] = useState(
		props.activeIndex || 0
	);
	const onGroupBtnClick = (index: number) => {
		setCurrentActiveIndex(index);
		props.onGroupBtnClick(index);
	};

	useEffect(() => {
		if (props.activeIndex !== undefined && props.activeIndex !== null) {
			setCurrentActiveIndex(props.activeIndex);
		}
	}, [props.activeIndex]);

	return (
		
			<div className="align-item">
				{props.buttons.map((item, i) => {
					return (
						<div className="zf-margin-r-m" key={item.title + i}>
							<ZFButton
								onBtnClick={() => onGroupBtnClick(i)}
								buttonClasses={["zf-text-medium"]}
								buttonType={
									i === currentActiveIndex
										? ButtonType.primary
										: ButtonType.secondary
								}
								href={item.href}
								state={
									i === currentActiveIndex
										? ButtonState.active
										: ButtonState.default
								}
								iconProperties={item.iconProperties}
							>
								{item.title}
							</ZFButton>
						</div>
					);
				})}
			</div>
	);
};

export default ZFGroupButton;

interface IZFGroupButton {
	onGroupBtnClick: (i: number) => void;
	buttons: IButtonElement[];
	activeIndex?: number;
}

export interface IButtonElement {
	title: string;
	iconProperties?: IconProperties;
	href?: string;
}
